import { useState } from 'react';
import './App.css';
import { Button, Divider, Flex, Form, Input, message, Space } from 'antd';
import { Typography } from 'antd';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from 'react-router-dom';

import { LeftCircleOutlined } from '@ant-design/icons';
import  * as  CopyToClipboard from 'react-copy-to-clipboard';

const { Title, Link } = Typography;
const { TextArea } = Input;

const Tools = () => {
    const [form] = Form.useForm();
    const [value, setValue] = useState('');
    const n = useNavigate();

    const onEncode = () => {
        setValue('');
        const text = form.getFieldValue('text');
        const result = Array.from(text)
            .map((char: any) => {
                return char.charCodeAt(0).toString(2).padStart(16, '0');
            })
            .join('')
            .replaceAll('0', '狐狐')
            .replaceAll('1', '啾咪');
        setValue(result);
        message.success('成功喵');
    };

    const onDecode = () => {
        setValue('');
        const text = form.getFieldValue('text');
        const binary = text
            .replace(/[^狐狐啾咪]/g, '')
            .replaceAll('狐狐', '0')
            .replaceAll('啾咪', '1');
        let binaryArray = binary.match(/.{1,16}/g);
        const result = binaryArray
            .map((bin: string) => {
                return String.fromCharCode(parseInt(bin, 2));
            })
            .join('');
        setValue(result);
        message.success('成功喵');
    };
    // 渲染数据
    return (
        <>
            <Flex align='center' gap={10}>
                {/* <Button
                    type='primary'
                    shape='circle'
                    icon={<LeftCircleOutlined />}
                    onClick={() => n('/dashboard')}
                /> */}
                <Title level={3} style={{ margin: '15px 0', flex: 1 }}>
                    狐言狐语生成器
                </Title>
            </Flex>
            <Divider />
            <Form layout='vertical' form={form} name='gettext' clearOnDestroy>
                <Form.Item
                    name='text'
                    label='需要加密/解密的文本'
                    rules={[
                        {
                            required: true,
                            message: '请输入需要加密或者解密的文本喵',
                        },
                    ]}>
                    <TextArea rows={4} />
                </Form.Item>
            </Form>
            <Space>
                <Button type='primary' onClick={onEncode}>
                    加密
                </Button>
                <Button type='primary' onClick={onDecode}>
                    解密
                </Button>
            </Space>
            {value && (
                <>
                    <Flex align='center' gap={10}>
                        <Title level={3} style={{ margin: '15px 0' }}>
                            转换结果
                        </Title>
                        <CopyToClipboard
                            text={value}
                            onCopy={() => message.success('复制好了喵')}>
                            <Button type='primary'>
                                复制
                            </Button>
                        </CopyToClipboard>
                    </Flex>
                    {value}
                </>
            )}
        </>
    );
};

export default Tools;
